import logo from '../../images/logo.png'
import { Layout } from "antd";
import { Link, useParams } from "react-router-dom";
import { Content, Header } from "antd/lib/layout/layout";
import './vote.css'
import DragDrop from "../../components/dragdrop/DragDrop";
import TokenInput from '../../components/tokeninput/TokenInput';
import { useState, useEffect } from 'react';

interface VoteProps {
    requestUrl: string
}

export interface PollInfo {
    id: number;
    question: string;
    options: any[];
    is_open: boolean;
    winner: null;
}


const Vote: React.FC<VoteProps> = ( { requestUrl } ) => {   
    const [voteToken, setVoteToken] = useState<string | undefined>(undefined)
    const [pollInfo, setPollInfo] = useState<PollInfo | undefined>(undefined)
    var { id } = useParams()

    const saveVoteToken = (input: string) => {
        setVoteToken(input)
    }

    const requestPollInfo = (values: {vote_token: string}, ) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        }
        fetch(`${requestUrl}/polling/polls/${id}/info/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setPollInfo(result)
            })
            .catch(error => console.log('error', error))
    }
    const tokenInputComponent = <TokenInput saveVoteToken={saveVoteToken} requestPollInfo={requestPollInfo}/>
    
    const [renderedContent, setRenderedContentent] = useState(tokenInputComponent)

    useEffect(() => {
        if(voteToken && pollInfo) {
            setRenderedContentent(<DragDrop id={id} voteToken={voteToken} pollinfo={pollInfo} requestUrl={requestUrl}/>)
        }
    }, [voteToken, requestUrl, pollInfo, id])

    

    return(
        <Layout className="site-layout-background">
            <Header className="navbar-layout-background" >
                <div className='vote-navbar'>
                    <div className='logo-area'>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <img className='logo' alt='logo' src={logo} />
                        </Link>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <h1>FairVote</h1>
                        </Link>
                    </div>
                </div>
            </Header>
            <Content className='vote_content'>
                {renderedContent}
            </Content>
        </Layout>
    )
};

export default Vote;
